const checkCameraAndMic = async () => {
  try {
    // Check if media devices are supported
    if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
      console.log("Media devices are not supported in this browser.");
      return { error: "Media devices not supported." };
    }

    // Enumerate devices to check for camera and mic
    const devices = await navigator.mediaDevices.enumerateDevices();
    const hasCamera = devices.some((device) => device.kind === "videoinput");
    const hasMic = devices.some((device) => device.kind === "audioinput");

    if (!hasCamera && !hasMic) {
      console.log("No camera or microphone found on this device.");
      return { error: "No camera or microphone found." };
    }

    console.log("Camera available:", hasCamera);
    console.log("Microphone available:", hasMic);

    return { hasCamera, hasMic };
  } catch (error) {
    console.error("Error checking camera and mic availability:", error);
    return { error: "Error checking media devices." };
  }
};

const checkMediaPermissions = async () => {
  try {
    const permissions = {};

    // Check microphone permission
    const micPermission = await navigator.permissions.query({
      name: "microphone",
    });
    permissions.microphone = micPermission.state; // "granted", "denied", or "prompt"

    // Check camera permission
    const cameraPermission = await navigator.permissions.query({
      name: "camera",
    });
    permissions.camera = cameraPermission.state; // "granted", "denied", or "prompt"

    console.log("Microphone permission:", permissions.microphone);
    console.log("Camera permission:", permissions.camera);

    return permissions;
  } catch (error) {
    console.error("Error checking media permissions:", error);
    return { error: "Error checking permissions." };
  }
};

export const checkMediaDevicesAndPermissions = async () => {
  try {
    const deviceStatus = await checkCameraAndMic();
    if (deviceStatus.error) {
      return deviceStatus;
    }

    const permissions = await checkMediaPermissions();

    return {
      ...deviceStatus,
      permissions,
    };
  } catch (error) {
    console.error("Error checking media devices and permissions:", error);
    return { error: "Error checking media devices and permissions." };
  }
};
